import React from 'react'
import { Mail } from 'lucide-react'

const Support: React.FC = () => (
  <div className="max-w-4xl mx-auto px-8 py-10">
    <nav className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-gray-500">
        <li>Docs</li>
        <li>/</li>
        <li className="text-gray-900 font-medium">Support</li>
      </ol>
    </nav>

    <h1 className="text-3xl font-bold text-gray-900 mb-4">
      <span className="text-primary-500">Support</span>
    </h1>
    <p className="text-gray-600 mb-12 leading-relaxed">
      Our team is here to help you succeed. Reach out anytime you need assistance with your school or listings.
    </p>

    <div className="grid grid-cols-1 gap-6 mb-8">
      <div className="bg-white border border-gray-200 rounded-xl p-6 hover:border-emerald-200 hover:shadow-md transition-all">
        <div className="w-12 h-12 rounded-lg bg-emerald-50 flex items-center justify-center mb-4">
          <Mail className="h-6 w-6 text-emerald-600" />
        </div>
        <h3 className="font-bold text-gray-900 mb-2">Email Support</h3>
        <p className="text-sm text-gray-600 mb-3">Get a response within 24 hours on business days.</p>
        <a href="mailto:info@bookmyyogattc.com" className="text-primary-600 font-medium text-sm hover:underline">
          info@bookmyyogattc.com
        </a>
      </div>
    </div>
  </div>
)

export default Support
